import global$1 from './global.js';

var global = global$1;
var String = global.String;

var tryToString = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};

export { tryToString as default };
